var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberTwo = function SvgIconNumberTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12.25a9 9 0 1 1-18 0 9 9 0 0 1 18 0m1 0c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10M9.927 8.875c.609-.371 1.49-.639 2.279-.592.763.045 1.378.37 1.663 1.14.166.446.17.846.043 1.259-.132.43-.41.893-.85 1.441-.44.547-1.012 1.146-1.702 1.852l-.368.375c-.597.608-1.265 1.288-1.978 2.058a.5.5 0 0 0 .367.84H15a.5.5 0 1 0 0-1h-4.46q.613-.637 1.163-1.195l.371-.378c.688-.703 1.294-1.335 1.767-1.926.473-.59.842-1.169 1.027-1.774a2.87 2.87 0 0 0-.061-1.9c-.459-1.238-1.497-1.729-2.542-1.79-1.02-.06-2.103.275-2.859.737a.5.5 0 1 0 .521.853",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberTwo;